import { createFileRoute } from '@tanstack/react-router'
import { WaitingOnPage } from '@/features/owed-items/waiting-on-page'

export const Route = createFileRoute('/_authenticated/projects/waiting-on')({
  staticData: { title: 'Waiting On' },
  component: WaitingOnPage,
})
